import React from "react";

import check from "../../assets/icons/check.svg";
import edit from "../../assets/icons/edit-3.svg";
import trash from "../../assets/icons/trash.svg";
import Axios from "axios";

export default class Item extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			unableToEdit: false,
			editedTitle: "",
		};

		this.deleteAnItem = this.deleteAnItem.bind(this);
		this.unableToEditHandler = this.unableToEditHandler.bind(this);
		this.onkeyPressHandler = this.onkeyPressHandler.bind(this);
		this.editItemHandler = this.editItemHandler.bind(this);
		this.saveEditedItem = this.saveEditedItem.bind(this);
	}

	deleteAnItem = () => {
		const url = `http://sys.niroomohareke.ir/backend/api/delete-${this.props.category}/${this.props.item.id}`;
		Axios.get(url).then((response) => {
			console.log(response.data);
		});
	};

	unableToEditHandler = () => {
		this.setState({ unableToEdit: true, editedTitle: this.props.item.title });
	};

	onkeyPressHandler = (event) => {
		if (event.keyCode === 27) {
			this.setState({ unableToEdit: false });
		}

		if (event.key === "Enter") {
			this.saveEditedItem();
		}
	};

	editItemHandler = (event) => {
		this.setState({ editedTitle: event.target.value });
	};

	// Have an issue => send request many time!
	saveEditedItem = () => {
		const url = "http://sys.niroomohareke.ir/backend/api/edit-todo";
		console.warn(this.state.editedTitle);
		Axios.put(url, { todo_id: this.props.item.id, title: this.state.editedTitle }).then((response) => {
			this.setState({ unableToEdit: false, editedTitle: "" });
		});
	};

	componentDidMount() {
		document.addEventListener("keydown", this.onkeyPressHandler, false);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onkeyPressHandler, false);
	}

	render() {
		return (
			<div className="w-full flex flex-row items-center p-3 bg-white shadow rounded mb-2">
				{this.state.unableToEdit === true ? (
					<input
						autoFocus
						onKeyPress={this.onkeyPressHandler}
						onChange={this.editItemHandler}
						value={this.state.editedTitle}
						className="w-full px-3 py-1 outline-none border rounded text-sm md:text-base"
					/>
				) : (
					<>
						<h3 className="ml-auto text-sm md:text-base" onClick={this.unableToEditHandler}>
							{this.props.item.title}
						</h3>

						<div className="flex items-center flex-row">
							<span className="mr-2 cursor-pointer">
								<img width="18" src={check} alt="Done" />
							</span>
							<span className="mr-2 cursor-pointer">
								<img width="18" src={edit} alt="Edit" />
							</span>
							<span onClick={this.deleteAnItem} className="mr-2 cursor-pointer">
								<img width="18" src={trash} alt="Delete" />
							</span>
						</div>
					</>
				)}
			</div>
		);
	}
}
